import React from 'react';
import loadable from '@loadable/component';
import { Props } from './content';

const SidebarMobileContentLoadable = loadable(() =>
  import(/* webpackChunkName: "sidebar-mobile" */ './content')
);

const SidebarMobileContent = (props: Props) => (
  <SidebarMobileContentLoadable {...props} />
);

export default SidebarMobileContent;
